import {Provider, Root} from '@radix-ui/react-tooltip';

export const Tooltip = Root;
export const TooltipProvider = Provider;

export * from './TooltipTrigger';
export * from './TooltipContent';
